import { schema } from "normalizr";

const currency = new schema.Entity(`currencies`);
const arrayOfCurrencies = [currency];

export { currency, arrayOfCurrencies };
